// Fichier : src/api.js
import axios from 'axios';
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const API_BASE = isLocalhost 
    ? 'http://localhost:5000/api' 
    : 'https://fac.arsn.ci/api';

const API = axios.create({
    baseURL: API_BASE
});

API.interceptors.request.use((req) => {
    const storedUser = localStorage.getItem('facsmart_user');
    if (storedUser) {
        try {
            const storedData = JSON.parse(storedUser);
            const token = storedData.token || (storedData.user && storedData.user.token);
            if (token) {
                req.headers.Authorization = `Bearer ${token}`;
            }
        } catch (e) {
            console.error("Erreur de lecture du token local", e);
        }
    }
    return req;
}, (error) => Promise.reject(error));

API.interceptors.response.use(
    (response) => response, 
    (error) => {
        if (error.response && error.response.status === 401) {
            console.warn("Session expirée, déconnexion...");
            localStorage.removeItem('facsmart_user'); 
            window.location.href = '/'; 
        }
        return Promise.reject(error);
    }
);

export const fetchDashboardStats = () => API.get('/dashboard/stats');

export const fetchPrestations = () => API.get('/prestations');
export const createPrestation = (payload) => API.post('/prestations', payload);
export const updatePrestation = (id, payload) => API.put(`/prestations/${id}`, payload);
export const deletePrestation = (id) => API.delete(`/prestations/${id}`);

export const fetchProformas = () => API.get('/proformas?type=proforma'); 
export const createProforma = (payload) => API.post('/proformas', { ...payload, type: 'proforma' });
export const updateProforma = (id, payload) => API.put(`/proformas/${id}`, payload);
export const deleteProforma = (id) => API.delete(`/proformas/${id}`);
export const exportProformaPDF = (id) => API.get(`/proformas/${id}/pdf`, { responseType: 'blob' });

export const fetchFactures = () => API.get('/factures?type=final'); 
export const fetchFactureById = (id) => API.get(`/factures/${id}`);
export const createFacture = (payload) => API.post('/factures', { ...payload, type: 'final' });
export const updateFacture = (id, payload) => API.put(`/factures/${id}`, payload);
export const deleteFacture = (id) => API.delete(`/factures/${id}`);
export const exportFacturePDF = (id) => API.get(`/factures/${id}/pdf`, { responseType: 'blob' });

export const createAvoir = (payload) => API.post('/factures', { ...payload, type: 'avoir' });
export const fetchAvoirs = () => API.get('/factures?type=avoir');
export const fetchAvoirById = (id) => API.get(`/factures/${id}`);
export const updateAvoir = (id, payload) => API.put(`/factures/${id}`, payload);
export const deleteAvoir = (id) => API.delete(`/factures/${id}`);
export const exportAvoirPDF = (id) => API.get(`/factures/${id}/pdf`, { responseType: 'blob' });


export const fetchLivraisons = () => API.get('/livraisons');
export const createLivraison = (payload) => API.post('/livraisons', payload);
export const updateLivraison = (id, payload) => API.put(`/livraisons/${id}`, payload);
export const deleteLivraison = (id) => API.delete(`/livraisons/${id}`);
export const exportLivraisonPDF = (id) => API.get(`/livraisons/${id}/pdf`, { responseType: 'blob' });

export const fetchClients = () => API.get('/clients');
export const createClient = (payload) => API.post('/clients', payload);
export const updateClient = (id, payload) => API.put(`/clients/${id}`, payload);
export const deleteClient = (id) => API.delete(`/clients/${id}`);
export const exportClientRedevancePDF = (clientId) => API.get(`/clients/${clientId}/redevance`, { responseType: 'blob' });

export const fetchEncaissements = () => API.get('/encaissements');
export const createEncaissement = (formData) => API.post('/encaissements', formData, { 
    headers: { 'Content-Type': 'multipart/form-data' } 
});
export const updateEncaissement = (id, payload) => API.put(`/encaissements/${id}`, payload);
export const deleteEncaissement = (id) => API.delete(`/encaissements/${id}`);
export const exportEncaissementPDF = (id) => API.get(`/encaissements/${id}/pdf`, { responseType: 'blob' });

export const exportTreasuryBook = (date) => API.get(`/encaissements/livre-tresorerie?date=${date}`, { responseType: 'blob' });
export const fetchDailyEncaissementStats = (year, month) => API.get(`/encaissements/stats/daily?year=${year}&month=${month}`);
export const createDecaissementSelection = (data) => API.post('/encaissements/decaissement-select', data);
export const createDecaissementByDate = (date) => API.post('/encaissements/decaissement-date', { date });
export const fetchDecaissementsHistory = () => API.get('/encaissements/decaissements');
export const cancelDecaissement = (id) => API.delete(`/encaissements/decaissement/${id}`);

export const loginUser = (credentials) => API.post('/auth/login', credentials);
export const updateUserProfile = (data) => API.put('/auth/update', data);
export const fetchAllUsers = () => API.get('/auth/users');
export const adminResetUserPassword = (data) => API.put('/auth/admin-reset', data);

export default API;